import { FlexBox } from 'src/ui/common/atoms/flex-box';
import styled, { css } from 'styled-components';
import { media } from 'src/ui/common/mixins/media';
import { Visible } from 'src/ui/common/layouts/visible';

export const StyledContainer = styled(FlexBox)`
  & > div:nth-child(1) {
    flex: 1;
  }
  
  button {
    height: 40px;
    
    ${media.md(css`
      height: 50px;
    `)}
  }
`;

export const StyledMobileActions = styled(Visible)`
    & > div {
      width: 100%;
      gap: 5px;
    }
`;
